import { createReducer, on } from "@ngrx/store";
import { CartModel } from "./cart.model";
import { resetCart, setCart } from "./cart.actions";


const initialStateCart: CartModel = {
  CartData: {
    cart_id: 0,
    establishment_name: "",
    establishment_id: "",
    products: [],
    total: 0
  }
};
export const cartReducer = createReducer(
  initialStateCart,
  on(setCart, (state, { CartData }) => ({
    ...state,
    CartData
  })),
  on(resetCart, () => initialStateCart)
);
